import { render, staticRenderFns } from "./UserProfileList.vue?vue&type=template&id=23166dad&scoped=true&"
import script from "./UserProfileList.vue?vue&type=script&lang=js&"
export * from "./UserProfileList.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileList.vue?vue&type=style&index=0&id=23166dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23166dad",
  null
  
)

export default component.exports